import { useCallback, useState } from 'react'

import type { ConfirmKeyInitiativesReviewParams } from '../api/confirmKeyInitiativesReview'
import { confirmKeyInitiativesReview } from '../api/confirmKeyInitiativesReview'

export const useConfirmKeyInitiativesReview = () => {
  const [isConfirmingReview, setIsConfirmingReview] = useState(false)
  const [hasConfirmReviewError, setHasConfirmReviewError] = useState(false)

  const confirmReview = useCallback(async (params: ConfirmKeyInitiativesReviewParams) => {
    setIsConfirmingReview(true)
    setHasConfirmReviewError(false)

    try {
      await confirmKeyInitiativesReview(params)
      return true
    } catch {
      setHasConfirmReviewError(true)
      return false
    } finally {
      setIsConfirmingReview(false)
    }
  }, [])

  return {
    confirmReview,
    isConfirmingReview,
    hasConfirmReviewError,
  }
}
